import React, { Component } from 'react';
import _, { isEmpty } from 'lodash';
import Notif from '../../../commonModules/interface/Notif';
import Image from '../../../commonModules/interface/Image';
import { TableRow, TableCell, Table, TableHead, TableBody, Box, IconButton } from '@material-ui/core';
import { GraphicEqRounded } from '@material-ui/icons';
import Dialog from '../../../commonModules/interface/Dialog';
import AudioPlayerSAV from '../../../commonModules/interface/AudioPlayerSAV';
import { BuildRounded, LaptopMacRounded, PersonRounded,  } from '@material-ui/icons';
import SwipeableTabs from '../../../commonModules/MUI/SwipeableTabs';
import { TimeLineBlock } from '../../../commonModules/interface/TimeLineMui';
import { Timeline } from '@material-ui/lab';
import { TableLayout } from '../Stock/containers/Layout';
import RichText from '../../../commonModules/interface/RichText';

const USERTYPE = {
    "tech": {icon: <BuildRounded  />, title: "Technicien", color:"primary"},
    "operator": {icon: <PersonRounded />, title: "Client", color:"lightPurple"},
    "leadTech": {icon: <LaptopMacRounded />, title: "Gestionnaire", color:"teal"} 
}

class SuiviReports extends React.PureComponent {
    state = {
        messagesIdList: [],
        // subHeaderMenu: [true, false],
          
    }       
    
    displayForms = (item) => { 
        console.log("[DEBUG],paygPopuInfo,displayForms item",item)
        if (item.forms && !(item.forms === null)&&!(item.forms === [null])) {
            console.log("[DEBUG],paygPopuInfo,displayForms item, inside",item.forms)
            if (item.forms[0] === null){
                return false
            }
            //Ajouter cas 
            if (typeof item.forms[0].photolist !== "undefined"){
                console.log("[DEBUG] >>> ",item.forms[0].photolist )
                return item.forms[0].photolist.map( (item,formKey ) => {
                        let infoD = item.split(":");
                        // console.log("[INSIDE], ", item, " - ", infoD)
                        // console.log("[INSIDE], ", infoD[2], " - ", infoD[1])
                        // console.log("[INSIDE], ",formKey," - ", item.substr(14))
                        return (
                            <TableRow key={formKey}>
                                <TableCell component="th">{"Photo : "+formKey}</TableCell>
                                <TableCell>
                                    <Image name={"Photo : "+formKey} src={item.substr(14)} image/> 
                                </TableCell>
                            </TableRow>
                        )
                    }
                )
            }

            //console.log("displayForms item",item , item.forms[0][0]);
            let formsList = item.forms[0][0] === undefined ? [item.forms] : item.forms

            return formsList.map(form =>{ 
                console.log("FORM FORMS",formsList );

                return form.map(subForm =>{ 
                    console.log("FORM subFORM", subForm );
                    if(subForm){

                        return Object.keys(subForm).map(formKey => {
                            let chaine = ""
                            chaine = (subForm[formKey]).toString()
                            console.log("FORM formKey, subForm[formKey] ", formKey ,subForm[formKey] );
                            
                            if(formKey === "XXXX Problème Résolu" || formKey === "validate"){
                                return (
                                    <TableRow key={formKey}>
                                        <TableCell>Problème Résolu</TableCell>
                                        <TableCell>{subForm[formKey] ? "Oui" : "Non"}</TableCell>
                                    </TableRow>
                                )
                            } else if (chaine.startsWith("data:download:")){// file image
                                
                                // this.getFile(chaine.substr(14))
                                return (
                                    <TableRow key={formKey}>
                                        <TableCell>{formKey}</TableCell>
                                        {/* <td> <img src={this.state.file} /> </td> */}
                                        <TableCell> <Image name={formKey} src={chaine.substr(14)} image/> </TableCell>
                                    </TableRow>
                                )
                            } else if (chaine.startsWith("data:csv:")){// file csv to download
                                
                                // this.getFile(chaine.substr(9))
                                return (
                                    <TableRow key={formKey}>
                                        <TableCell>{formKey}</TableCell>
                                        <TableCell><Image name={formKey} src={chaine.substr(9)} csv/></TableCell>
                                    </TableRow>
                                )
                            } else if (chaine.startsWith("data:")){// file csv to download
                                let infoD = chaine.split(":");

                                return (
                                    <TableRow key={formKey}>
                                        <TableCell>{formKey}</TableCell>
                                        <TableCell><Image name={formKey} src={infoD[2]} mime={infoD[1]} other/></TableCell>
                                    </TableRow>
                                )
                            } else {
                                return (
                                    <TableRow key={formKey}>
                                        <TableCell>{formKey}</TableCell>
                                        <TableCell>{subForm[formKey]}</TableCell>
                                    </TableRow>
                                )
                            }
                        })                                        
                    }
                })                                        
            })
        }
        return false
    }

    render() {
        console.log("STATE POPUP",this.state);
        console.log("PROPS", this.props);
        const audios = this.props.audios || [];
        const audioAction = !isEmpty(audios) ? (
            <IconButton
                size="small"
                color="secondary"
                title="Audio & transcription"
                onClick={() => this.setState({ showAudioModal: true })}
            >
                <GraphicEqRounded />
            </IconButton>
        ) : null;

        return (

            <Box>
                <SwipeableTabs
                    default="Commentaires"
                    labels={["Commentaires", "Formulaires"]}
                >
                    <Box p={1}>
                        <Timeline>
                        {/* <Timeline  align="alternate"> */}
                            { this.props.comments.filter(item => !isEmpty(item.comment)).map((item, idx) => {
                                let step = {
                                    date: new Date(item.ts).toLocaleString('fr-FR') || item.ts,
                                    icon: USERTYPE[item.userType].icon,
                                    title: USERTYPE[item.userType].title,
                                    color: USERTYPE[item.userType].color,
                                    content: (
                                        <div>
                                            <RichText text={item.comment} />
                                            {idx === 0 && audioAction ?
                                                <div style={{ textAlign: 'right', marginTop: 4 }}>
                                                    {audioAction}
                                                </div>
                                            : null}
                                        </div>
                                    ),
                                }
                                return (
                                    <TimeLineBlock step={step} />
                                );
                            })
                            }
                        </Timeline>
                    </Box>
                    <Box p={1}>
                        <Timeline >
                            { this.props.comments.filter(item => !isEmpty(item.forms)).map(item => {
                                let step = {
                                    date: new Date(item.ts).toLocaleString('fr-FR') || item.ts,
                                    icon: USERTYPE[item.userType].icon,
                                    title: USERTYPE[item.userType].title,
                                    content:
                                        <TableLayout>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell colSpan={2}>{USERTYPE[item.userType].title}</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>

                                                {this.displayForms(item)}
                                            </TableBody>
                                        </TableLayout>
                                    ,
                                }
                                return (
                                    <TimeLineBlock step={step} />
                                );
                            })
                            }
                        </Timeline>
                    </Box>
                </SwipeableTabs>
                {this.state.showAudioModal && !isEmpty(audios) &&
                    <Dialog
                        title="Audio & transcription"
                        block={true}
                        text={
                            <Box p={1}>
                                {audios.map((audio, idx) => (
                                    <AudioPlayerSAV key={audio.audioId || idx} audio={audio} />
                                ))}
                            </Box>
                        }
                        close={() => this.setState({ showAudioModal: false })}
                    />
                }
            </Box>

        );
    }
}

export default SuiviReports;